import * as React from "react";
const SvgDropdown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 12.7706L15.3727 12L12.0001 14.723L8.6273 12L8 12.7706L12 16L16 12.7706Z", fill: "white" }));
export default SvgDropdown;
